import * as React from "react";
import pageIds from "~/pageIds";
import type { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import { CommonConfigurationRoleOverview } from "../../CommonComponents/CommonConfigurationRoleViews";
export const ConfigurationRolesRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.configuration.roles.root,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonConfigurationRoleOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => null,
};
